import { GET_LAWYER_USERS, GET_LAWYER_USERS_BY_ID, GET_LAWYER_USERS_EMPTY, CHANGE_TAB } from "../actions/LaywerUserAction";

const initialState = {
    laywerData: {},
    laywerById: {},
    laywerEmpty: {},
    filterTab: 'lawFirm',
}

const paginationReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case GET_LAWYER_USERS:
            return {
                ...state,
                laywerData: action.data
            }
        case GET_LAWYER_USERS_BY_ID:
            return {
                ...state,
                laywerById: action.data
            }
        case GET_LAWYER_USERS_EMPTY:
            return {
                ...state,
                laywerEmpty: action.data
            }
        case CHANGE_TAB:
            return {
                ...state,
                filterTab: action.data
            }
        default: return state
    }
}

export default paginationReducer;
